import { RoominglistGenerationCriteria } from "../objects/roomingListGeneration";
import { RoominglistHistoryCriteria } from "../objects/roomingListHistory";

export const EMPTY_ROOMING_LIST_HISOTRY_CRITERIA: RoominglistHistoryCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
};


export const EMPTY_ROOMING_LIST_GENERATION_CRITERIA: RoominglistGenerationCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
};
